import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const NavigationView = () => import('@/pages/NavigationView');
const Index = () => import('@/pages/home/Index');
const Login = () => import('@/pages/Login');
const Store = () => import('@/pages/store/Index');
const Product = () => import('@/pages/product/Index');
const Order = () => import('@/pages/order/Index');
const OrderReport = () => import('@/pages/order/OrderReport');
const ProductType = () => import('@/pages/product/productType');
const ProductImages = () => import('@/pages/product/productImages');
const About = () => import('@/pages/about/Index');
const Sale = () => import('@/pages/sale/Index');
const User = () => import('@/pages/users/Index');
const OrderView = () => import('@/pages/order/OrderView');
const Payment = () => import('@/pages/payment/Index');
const News = () => import('@/pages/news/Index');

const Report = () => import('@/pages/product/report');

const LotteryRecord = () => import('@/pages/product/lotteryRecord.vue');
const Invoice = () => import('@/pages/invoice/Index');

const Vendor = () => import('@/pages/vendor/Index');
const Label = () => import('@/pages/label/Index');
const Giveaway = () => import('@/pages/giveaway/Index');
const PaymentSetting = () => import('@/pages/paymentSetting/Index');
const BuyTicket = () => import('@/pages/buyTicket/Index');

const Recycle = () => import('@/pages/product/recycle.vue');
const InstantDraw = () => import('@/pages/instantDraw/Index');
const AdminLottery = () => import('@/pages/product/adminLottery.vue');
const OrderNotShipped = () => import('@/pages/orderNotShipped/Index');

const WorldBoss = () => import('@/pages/worldBoss/Index');

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/orderView',
            name: 'OrderView',
            component: OrderView,
        },
        {
            path: '/admin',
            name: 'NavigationView',
            component: NavigationView,
            children: [
                {
                    path: 'index',
                    name: 'home',
                    component: Index,
                },
                {
                    path: 'store',
                    name: 'store',
                    component: Store,
                },
                {
                    path: 'product',
                    name: 'product',
                    component: Product,
                },
                {
                    path: 'productType',
                    name: 'ProductType',
                    component: ProductType,
                },
                {
                    path: 'productImage',
                    name: 'productImage',
                    component: ProductImages,
                },
                {
                    path: 'order',
                    name: 'order',
                    component: Order,
                },
                {
                    path: 'orderNotShipped',
                    name: 'orderNotShipped',
                    component: OrderNotShipped,
                },
                {
                    path: 'orderReport',
                    name: 'orderReport',
                    component: OrderReport,
                },
                {
                    path: 'about',
                    name: 'about',
                    component: About,
                },
                {
                    path: 'sale',
                    name: 'sale',
                    component: Sale,
                },
                {
                    path: 'user',
                    name: 'user',
                    component: User,
                },
                {
                    path: 'payment',
                    name: 'payment',
                    component: Payment,
                },
                {
                    path: 'invoice',
                    name: 'invoice',
                    component: Invoice,
                },
                {
                    path: 'news',
                    name: 'news',
                    component: News,
                },
                {
                    path: 'report',
                    name: 'report',
                    component: Report,
                },
                {
                    path: 'lotteryRecord',
                    name: 'lotteryRecord',
                    component: LotteryRecord,
                },
                {
                    path: 'vendor',
                    name: 'vendor',
                    component: Vendor,
                },
                {
                    path: 'recycle',
                    name: 'recycle',
                    component: Recycle,
                },
                {
                    path: 'label',
                    name: 'label',
                    component: Label,
                },
                {
                    path: 'giveaway',
                    name: 'giveaway',
                    component: Giveaway,
                },
                {
                    path: 'paymentSetting',
                    name: 'paymentSetting',
                    component: PaymentSetting,
                },
                {
                    path: 'buyTicket',
                    name: 'buyTicket',
                    component: BuyTicket,
                },
                {
                    path: 'instantDraw',
                    name: 'instantDraw',
                    component: InstantDraw,
                },
                {
                    path: 'adminLottery',
                    name: 'adminLottery',
                    component: AdminLottery,
                },
                {
                    path: 'worldBoss',
                    name: 'worldBoss',
                    component: WorldBoss,
                },
            ],
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    console.log(`from == ${from.path} / ${to.path}`);
    if (to.path === '/'){
        return next('login');
    }
    if (to.path.indexOf('index') > -1 || to.path.indexOf('login') > -1 || to.path.indexOf('orderView') > -1) {
        return next();
    }
    return next();
});

export default router;
